import { gql } from "@apollo/client";

export const GET_ALL_CLIENT_LOGINS = gql`
  query GetAllClientLogins($search: String, $isActive: Boolean, $page: Int, $limit: Int) {
    getAllClientLogins(search: $search, isActive: $isActive, page: $page, limit: $limit) {
      status
      message
      totalCount
      records {
        id
        clientId
        clientName
        email
        mustChangePassword
        isActive
        loginLabel
        createdBy { empid name email }
        deactivatedAt
        deactivatedBy { empid name }
        lastLogin
        passwordChangedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_CLIENT_LOGINS_BY_CLIENT = gql`
  query GetClientLoginsByClient($clientId: String) {
    getClientLoginsByClient(clientId: $clientId) {
      status
      message
      totalCount
      records {
        id
        clientId
        clientName
        email
        mustChangePassword
        isActive
        loginLabel
        createdBy { empid name email }
        lastLogin
        createdAt
      }
    }
  }
`;

export const CREATE_CLIENT_LOGIN = gql`
  mutation CreateClientLogin($input: CreateClientLoginInput!) {
    createClientLogin(input: $input) {
      status
      message
      tempPassword
      record {
        id
        clientId
        clientName
        email
        mustChangePassword
        isActive
        loginLabel
        createdBy { empid name email }
        createdAt
      }
    }
  }
`;

export const REGENERATE_CLIENT_LOGIN_PASSWORD = gql`
  mutation RegenerateClientLoginPassword($id: String!) {
    regenerateClientLoginPassword(id: $id) {
      status
      message
      tempPassword
      record { id email mustChangePassword passwordChangedAt }
    }
  }
`;

export const DEACTIVATE_CLIENT_LOGIN = gql`
  mutation DeactivateClientLogin($id: String!, $actorEmpid: String, $actorName: String) {
    deactivateClientLogin(id: $id, actorEmpid: $actorEmpid, actorName: $actorName) {
      status
      message
      record { id isActive deactivatedAt deactivatedBy { empid name } }
    }
  }
`;

export const REACTIVATE_CLIENT_LOGIN = gql`
  mutation ReactivateClientLogin($id: String!) {
    reactivateClientLogin(id: $id) {
      status
      message
      record { id isActive deactivatedAt }
    }
  }
`;

export const DELETE_CLIENT_LOGIN = gql`
  mutation DeleteClientLogin($id: String!) {
    deleteClientLogin(id: $id) {
      status
      message
    }
  }
`;
